import type { FC } from "react";

import { useTranslation } from "src/translations";
import { CustomerStatusEnum } from "src/types";
import { tableModule } from "./table";
import { createActionsForSelection, overrideRowProps } from "./utils";

export const All: FC = () => {
    const { t } = useTranslation();

    return (
        <tableModule.Container
            isSelectable={(row) => !!(row?.parentId || row.subRows?.length > 0)}
            actionsForSelection={createActionsForSelection(t)}
            overrideRowProps={overrideRowProps}
            isExpandable
            defaultTableConfig={{ initialFilters: { status: CustomerStatusEnum.Active } }}
        />
    );
};
